// api.js
import api from "./api"

export const authService = {
    login: async (email, password) => {
        try {
            const response = await api.post('/login', {
                Email: email,
                Password: password
            });
            localStorage.setItem('token', response.data.token);
            return response.data;
        } catch (error) {
            console.log('Erro completo:', error);
            console.log('Resposta do servidor:', error.response);
            console.log('Status:', error.response?.status);
            console.log('Mensagem:', error.response?.data);
            throw new Error('Erro ao fazer login');
        }
    },
    register: async (name, email, password) => {
        try {
            const response = await api.post('/register', {
                Name: name,
                Email: email,
                Password: password
            });
            localStorage.setItem('token', response.data.token);
            return response.data;
        } catch (error) {
            throw new Error('Erro ao se registrar');
        }
    },
    logout: async () => {
        try {
            const response = await api.post('/logout');
            localStorage.removeItem('token');
            return response.data;
        } catch (error) {
            throw new Error('Erro ao fazer logout');
        }
    },
    refreshToken: async () => {
        try {
            const response = await api.post('/refresh-token');
            localStorage.setItem('token', response.data.token);
            return response.data;
        } catch (error) {
            throw new Error('Erro ao atualizar token');
        }
    }
};

export default authService;